import { getCarEBoxLocations } from './getCarEBoxLocations';
import { resetCarEBoxLocations } from './resetCarEBoxLocations';
import { resetSelectedCarEBoxLocation } from './resetSelectedCarEBoxLocation';
import { resetSelectedCar } from './resetSelectedCar';
import { updateSelectedCar } from './updateSelectedCar';
import { getADRClasses } from './getADRClasses';
import { getLocationSharingConstraints } from './getLocationSharingConstraints';
import { addLocationSharing } from './addLocationSharing';
import { getCarsLocationSharing } from './getCarsLocationSharing';
import { updateVisibilityEBoxLocations } from './updateVisibilityEBoxLocations';
import { deleteCarLocationSharing } from './deleteCarLocationSharing';
import { getCarLocationHistorySharing } from './getCarLocationHistorySharing';
import { updateCarsLocationHistorySharingFilter } from './updateCarsLocationHistorySharingFilter';
import { updateCarLocationHistorySharingSelectedLocation } from './updateCarLocationHistorySharingSelectedLocation';
import { updateSelectedCarLocationAutoNumber } from './updateSelectedCarLocationAutoNumber';
import { resetLocationSharingState } from './resetLocationSharingState';
import { updateCarEBoxLocationsFilter } from './updateCarEBoxLocationsFilter';

export const carOperations = {
  getCarEBoxLocations,
  resetCarEBoxLocations,
  updateVisibilityEBoxLocations,

  resetSelectedCarEBoxLocation,
  updateSelectedCar,
  updateCarEBoxLocationsFilter,
  resetSelectedCar,

  getADRClasses,
  getLocationSharingConstraints,
  addLocationSharing,
  getCarsLocationSharing,
  deleteCarLocationSharing,
  getCarLocationHistorySharing,
  updateCarsLocationHistorySharingFilter,
  updateCarLocationHistorySharingSelectedLocation,
  updateSelectedCarLocationAutoNumber,
  resetLocationSharingState
};
